export default "__VITE_ASSET__C8gn1QLO__"